import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/ProduitFaceDoubleAffectationView/';
export default async function getAllProduitFaceSuiviAffectation(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}
